module.exports = __webpack_public_path__ + "static/blog-header-93f3130c1fc9d18022c3b1a5b1ce680e.png";